import type { ReactNode } from 'react'
import React, { forwardRef } from 'react'
import { H2, Subheading } from '../typography'
import { Ellipsis } from '..'

type DialogHeaderProps = {
  title?: ReactNode
  subtitle?: ReactNode
  busy?: boolean
}

export default forwardRef<HTMLDivElement, DialogHeaderProps>(({ title, subtitle, busy }, ref): JSX.Element | null => {
  return title ? (
    <div
      // We focus the header for better accessibility. We have tested this with real blind users.
      // wrapping the H2 in an extra div so the screen readers will announce the subtitle as well
      tabIndex={-1}
      style={{ outline: 'none' }}
      data-overlay-header
      role="group"
      aria-busy={Boolean(busy)}
      aria-live="polite"
      aria-atomic="true"
      ref={ref}
    >
      <H2 size="H5">
        <Ellipsis>{title}</Ellipsis>
        {subtitle && <Subheading as="div">{subtitle}</Subheading>}
      </H2>
    </div>
  ) : (
    <>&nbsp;</> // We need something here, so that the close affordance stays pushed to the right.
  )
})
